import { Row, Col, Table, Popconfirm, Form, Input, DatePicker } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Panel from '../../../../../shared/components/card/Panel';
// import FormFormattedAmount from '../../../../../shared/components/crmFormElement/FormFormattedAmount/FormFormattedAmount';
// import { FormTextInput } from '../../../../../shared/components/crmFormElement/FormInputText/FormInputText';
import { GUTTOR_SPACE } from '../../../../../shared/constants/commonConstants';
// import { AdmissionContext } from '../../../../crm/inPatient/newAdmission/AdmissionContext';
import ReconciliationClaimDetailHeader from './ReconciliationClaimDetailHeader';
import { ReactComponent as PlusWithCircle } from '../../../../../assets/images/svg/plus_with_circle.svg';
import { TABLE_SIZE_MIDDLE } from '../../../../../shared/constants/crmConstants';
import { getDefaultStr } from '../../../../crm/inPatient/service/crmUtils';
import { getDateWithTextMonthForDDMMYYYY } from '../../../../../utils/dateTimeUtils';
import NumberFormatView from '../../../../../shared/components/NumberFormatView/NumberFormatView';
import { useDispatch, useSelector } from 'react-redux';
import { ReconciliationState, UpdatedReconciliationColsData } from '../../../../../store/models/reconciliationModel';
import { setReconciliationClaimDetail, updatedReconciliationColsData as updatedReconciliationColsDataAction } from '../../../../../store/actions/reconciliationAction';
import { RootState } from '../../../../../store';
import { RECONCILIATION_LINKED_CLAIMS_COLUMNS } from '../../../../../shared/constants/reconciliationConstants';
import { useHistory } from 'react-router-dom';
import { base64UrlEncode } from '../../../../../utils/utility';
const ReconciliationDetail = (): any => {
  const RECONCILIATION_DETAIL_COLUMNS = [
    {
      title: 'UTR No.',
      dataIndex: 'utrNumber',
      key: 'utrNumber',
      editable: true,
      render: (utrNumber: any): any => (
        getDefaultStr(utrNumber, true)
      ),
    },
    {
      title: 'UTR Settled Date',
      dataIndex: 'utrDate',
      key: 'utrDate',
      editable: true,
      render: (date: any): any => (
        date ? getDateWithTextMonthForDDMMYYYY(date) : getDefaultStr(date, true)
      ),
    },
    {
      title: 'Approved Amount',
      dataIndex: 'claimAppprovedAmount',
      key: 'claimAppprovedAmount',
      editable: true,
      render: (amount: any): any => (
        amount ? <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
        : getDefaultStr(amount, true)
      ),
    },
    {
      title: 'Settled Amount',
      dataIndex: 'utrSetteledAmount',
      key: 'utrSetteledAmount',
      editable: true,
      render: (amount: any): any => (
        amount ? <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
        : getDefaultStr(amount, true)
      ),
    },
    {
      title: 'TDS',
      dataIndex: 'tdsAmount',
      key: 'tdsAmount',
      editable: true,
      render: (amount: any): any => (
        amount ? <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
        : getDefaultStr(amount, true)
      ),
    },
    {
      title: 'Reconciliation Comments',
      dataIndex: 'comments',
      key: 'comments',
      editable: true,
      render: (comments: any): any => (
        getDefaultStr(comments, true)
      ),
    },
    {
      title: '',
      dataIndex: 'operation',
      render: (_: any, record: { reconciliationAuditTrailId: any; }): any =>
      detailColsData.length >= 1 && isReconciliationEditable ? (
          <Popconfirm title="Sure to delete?" onConfirm={(): any => handleDelete(record.reconciliationAuditTrailId)}>
            <a>Delete</a>
          </Popconfirm>
        ) : null,
    },
  ];
  // const admissionContext = useContext(AdmissionContext);
  // const { claimDetailBackup } = admissionContext;
  // const commonDetail = { form, claimDetailBackup };
  const {isReconciliationEditable, reconciliationClaimDetail, manualReconciliationData, updatedReconciliationColsData,
    reconciliationLinkedClaims} = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  const [detailColsData, setDetailColsData] = useState<UpdatedReconciliationColsData[]>([]);
  const [rowCount, setRowCount] = useState(0);

  const dispatch = useDispatch();
  const EditableContext = React.createContext(null);
  const history = useHistory();
  const handleDelete = (key: any): any => {
    const newData = detailColsData.filter((item: any): any => item.key !== key);
    setDetailColsData(newData); };

  useEffect((): any => {
    if (manualReconciliationData.length !== 0) {
      setDetailColsData(manualReconciliationData);
    }
  }, [manualReconciliationData]);

  useEffect((): any => {
    if (updatedReconciliationColsData.length === 0) {
      setDetailColsData(manualReconciliationData);
    }
  }, [updatedReconciliationColsData]);

  const addRow = (): any => {
    const newData = {
      key: 'newRow',
      utrNumber: '',
      utrDate: '',
      claimAppprovedAmount: null,
      utrSetteledAmount: null,
      tdsAmount: null,
      comments: '',
      reconciliationMasterId: reconciliationClaimDetail.reconciliationMasterId,
      reconciliationAuditTrailId: rowCount + 1,
    };
    setDetailColsData([...detailColsData , newData]);
    setRowCount(rowCount + 1);
  };

  const EditableRow = ({ index, ...props }: any): any => {
    const [form] = Form.useForm() as any;
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    // tslint:disable-next-line:trailing-comma
    ...restProps
  }: any): any => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null) as any;
    const form = useContext(EditableContext) as any;
    useEffect((): any => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
    const toggleEdit = (): any => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
    const save = async (): Promise<any> => {
      try {
        const values = await form.validateFields();
        values[Object.keys(values)[0]] =
        ['claimAppprovedAmount', 'utrSetteledAmount', 'tdsAmount'].includes(Object.keys(values)[0])
        ? parseFloat(typeof Object.values(values)[0] === 'string' ? (Object.values(values)[0] as any)
        .replaceAll(',', '') : Object.values(values)[0]) : Object.values(values)[0];
        toggleEdit();
        handlesave({
          ...record,
          ...values,
        });
      } catch (errInfo) {}
    };
    let childNode = children;
    if (editable && isReconciliationEditable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}>
          { dataIndex === 'utrDate' ?
            <DatePicker ref={inputRef} onSelect= {save} onBlur={save} placeholder="dd/mm/yyyy"/>
            : <Input ref={inputRef} onPressEnter={save} onBlur={save} />
          }
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };
  const handlesave = (row: { reconciliationAuditTrailId: any; }): any => {
    // tslint:disable-next-line
    const newData = [...detailColsData];
    const index = newData.findIndex((data: any): any => row.reconciliationAuditTrailId === data.reconciliationAuditTrailId);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    newData.forEach((d: any): any => { if (d.key) { delete d.key; d.reconciliationAuditTrailId = 0; } });
    setDetailColsData(newData);
    dispatch(updatedReconciliationColsDataAction(newData));
  };
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const ManualClaimsColumns = RECONCILIATION_DETAIL_COLUMNS.map((col: any): any => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any): any => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handlesave,
      }),
    };
  });

  const onRowClick = (event: any, record: any, rowIndex: any): any => {
    history.push(`/reconciliation/reconciliation-new/detail/${base64UrlEncode(JSON.stringify(record))}`);
     dispatch(setReconciliationClaimDetail(record));
    };

  useEffect((): any => {
    setRowCount((detailColsData as any).length);
  }, [detailColsData]);

  return <Panel className="member-scroll" data-testid="member-detail-card">
    <ReconciliationClaimDetailHeader />
    {
      isReconciliationEditable &&
        <Row gutter={GUTTOR_SPACE} className="flex-element justify-end w-100">
          <Col >
            <PlusWithCircle onClick={addRow}/>
          </Col>
        </Row>
    }
    <Table
      data-testid="manual-claims-list"
      components={components}
      rowClassName={(): any => 'editable-row'}
      size={ TABLE_SIZE_MIDDLE }
      columns={ ManualClaimsColumns }
      dataSource={ detailColsData }
      pagination={false}
      />
      {
        reconciliationLinkedClaims.length > 0 &&
        <>
          <h3 className="m-10 mt-lg ml-0">Linked Claims</h3>
          <Table
          data-testid="linked-claim-list"
          size={ TABLE_SIZE_MIDDLE }
          columns={ RECONCILIATION_LINKED_CLAIMS_COLUMNS }
          dataSource={ reconciliationLinkedClaims }
          pagination={false}
          onRow={(record: any, rowIndex: any): any => {return {
            onClick: (event: any): any => onRowClick(event, record, rowIndex),
          };
        }}
          />
        </>
      }
    {/* <Row gutter={GUTTOR_SPACE}>
      <Col md={12}>
        <FormFormattedAmount detail={{
          ...commonDetail,
          key: 'approvedAmountDischarge',
          label: 'Claim Approved Amount(at DOD)',
          addonBefore: '₹ ',
        }} />    </Col>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'tdsPercentage',
          label: 'TDS',

        }} />    </Col>
      <Col md={12}>
        <FormFormattedAmount detail={{
          ...commonDetail,
          key: 'claimedAmount',
          label: 'Claim approved Amount (at settlement)',
          addonBefore: '₹ ',
        }} />    </Col>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'comment',
          label: 'Reconciliation Comments',
        }} />    </Col>
      <Col md={12}>
        <FormFormattedAmount detail={{
          ...commonDetail,
          key: 'utrSettledAmount',
          label: 'UTR setteled amount',
          addonBefore: '₹ ',

        }} />    </Col>
    </Row> */}
  </Panel>;
};
export default ReconciliationDetail;
